import {
  AccordionChild,
  Section,
  TextParagraph,
  TitleAndDescription,
} from '@ferreri/prever-component-lib';

export const Faq = () => {
  return (
    <Section>
      <TitleAndDescription
        title="Dúvidas?"
        description="Confira a lista de perguntas frequentes, sua dúvida pode estar respondida ali. Caso não encontre sua dúvida você ainda pode falar com um consultor."
      />
      <AccordionChild items={questionsAndAnswers} />
    </Section>
  );
};

const questionsAndAnswers = [
  {
    title: `Quais são as formas de pagamento disponíveis?`,
    content: (
      <TextParagraph>
        A forma de pagamento é via cartão de crédito recorrente. O valor é
        creditado mensalmente na fatura do cartão de crédito sem usar do limite.
        Os dados do cartão serão solicitados no final da compra.
      </TextParagraph>
    ),
  },
  {
    title: `Qual o plano ideal para mim?`,
    content: (
      <TextParagraph>
        Para a escolha do plano, você pode partir da premissa de uma contratação
        individual ou não. Para um plano que atenda somente você, temos o plano
        Neo. Para atender você e seus familiares, temos o Essencial, Bem Estar,
        Bem Seguro e Multiassistência.
        <br />
        Compare os planos e faça uma simulação incluindo benefícios opcionais e
        dependentes para entender o plano ideal para o seu caso.
      </TextParagraph>
    ),
  },
  {
    title: `Os planos cobrem todos os custos no momento do sepultamento?`,
    content: (
      <TextParagraph>
        Sim. Independente do plano escolhido, todos possuem a assistência
        funeral que garante todas as necessidades para a realização de um
        sepultamento, como urna com alça parreira e visor, paramentos para
        cerimônia fúnebre, coroa de flores, orientação do processo de registro
        de óbito, veículo para remoção, entre outros. Confira os detalhes dos
        planos para saber mais sobre cada benefício.
      </TextParagraph>
    ),
  },
  {
    title: `Posso incluir dependentes que não sejam cônjuge e filhos?`,
    content: (
      <TextParagraph>
        Sim, é possível incluir pai, mãe, sogro(a), avô(ó), sobrinho(a),
        enteado(a), entre outros. <br />
        Para incluir dependentes que não sejam somente cônjuge e filhos, opte
        por um plano que aceite a inclusão de dependentes com os graus de
        parentesco pretendidos. <br />
        Escolha um plano e faça uma simulação para conferir as regras dos
        dependentes que você pretende incluir.
      </TextParagraph>
    ),
  },
  {
    title: `Posso incluir mais dependentes depois da contratação?`,
    content: (
      <TextParagraph>
        Sim. Após a contratação do Plano, você poderá incluir seus dependentes
        via WhatsApp. Nossa equipe entrará em contato para coletar os dados
        essenciais dos seus dependentes.
      </TextParagraph>
    ),
  },
];
